export const lowerCaseRegex = /^(?=.*[a-z])/gm
export const upperCaseRegex = /^(?=.*[A-Z])/gm
export const numberRegex = /^(?=.*\d)/gm
export const specialCharactersRegex =
  /^(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])/gm

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{12,128}$/gm

// ^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};':"\\|,.<>\\/?]).{12,128}$
export const passwordRegexString = passwordRegex
  .toString()
  .substring(1)
  .replace('/gm', '')
